import React from "react";
import "./listEventType.scss";

import { Col, Row, Stack } from "react-bootstrap";
import { gestioneSnackbar } from "../../utils/common";
import { t } from "i18next";

const ListEventType = ({
  data,
  title,
  textColor,
  selected,
  setSelected,
  disabled = true,
  max = 3,
}) => {
  return (
    <>
      <Stack gap={3}>
        <h2
          className="title-event-type"
          style={textColor ? { color: textColor } : null}
        >
          {title}
        </h2>

        <Row sm={2} md={3} className="g-2">
          {data.map((item) => {
            return (
              <Col
                key={item.id}
                className="d-flex justify-content-center align-items-center"
              >
                <BoxEventType
                  id={item.id}
                  name={item.name}
                  disabled={disabled}
                  setSelected={setSelected}
                  selected={selected}
                  max={max}
                />
              </Col>
            );
          })}
        </Row>
      </Stack>
    </>
  );
};

const BoxEventType = ({ id, name, setSelected, selected, disabled, max }) => {
  const handleSelect = (item) => {
    if (!disabled) {
      setSelected((prev) => {
        if (prev.includes(item)) {
          return prev.filter((i) => i !== item); // Rimuove se già selezionato
        } else if (prev.length < max) {
          return [...prev, item];
        }
        gestioneSnackbar(
          true,
          t("validation.max_event_type", { number: max }),
          "error"
        );
        return prev; // Non fa nulla se sono già 3
      });
    }
  };

  return (
    <div
      className="p-2 d-flex justify-content-center align-items-center box-event-type"
      style={
        disabled
          ? null
          : { border: selected.includes(id) ? "solid 2px #608ABD" : null }
      }
      onClick={() => (disabled ? null : handleSelect(id))}
    >
      <span>{name}</span>
    </div>
  );
};

export default ListEventType;
